export const CANTRATE_ID = 123456789;
export const CANTRATE_TEXT = 'Не могу оценить';
